import React from "react";

const PageHeader = ({
  title,
  subtitle,
  rightContent,
  leftContent,
  role = "admin", // 👈 default admin
}) => {

  const isAgent = role === "agent";

  return (
    <div
      className={`
        -mx-3 md:-mx-6 px-6 py-2 mb-6
        font-semibold text-lg
        ${isAgent 
          ? "bg-gradient-to-r from-orange-500/90 to-amber-200/90 text-gray-900"
          : "bg-white border-b border-gray-200 text-gray-900"
        }
      `}
    >
      <div className="flex items-center justify-between">
<div className="flex items-center gap-3">
            {leftContent && (
              <div className="flex items-center">
                {leftContent}
              </div>
            )}
        <div>
          <h1 className="text-lg md:text-xl font-semibold">
            {title}
             
          </h1>
{subtitle && (
            <p className="text-xs opacity-80">
              {subtitle}
            </p>
          )}
         
        </div>

        {rightContent && (
          <div>
            {rightContent}
          </div>
        )}
</div>
      </div>
    </div>
  );
};

export default PageHeader;
